import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import type { TChatAdminMessageProps } from '../../types';

export const ChatAdminMessage = ({ message }: TChatAdminMessageProps) => (
    <View className="px-md mb-4 items-center">
        <Text className="text-sm text-gray-500 text-center max-w-[300px]">{message.message}</Text>
    </View>
);
